const europeanCountries = [
    { label: "Austria", value: "AT", languages: ["German"] },
    { label: "Belgium", value: "BE", languages: ["Dutch", "French", "German"] },
    { label: "Croatia", value: "HR", languages: ["Croatian"] },
    { label: "Czech Republic", value: "CZ", languages: ["Czech"] },
    { label: "Denmark", value: "DK", languages: ["Danish"] },
    { label: "Estonia", value: "EE", languages: ["Estonian"] },
    { label: "Finland", value: "FI", languages: ["Finnish", "Swedish"] },
    { label: "France", value: "FR", languages: ["French"] },
    { label: "Germany", value: "DE", languages: ["German"] },
    { label: "Greece", value: "GR", languages: ["Greek"] },
    { label: "Hungary", value: "HU", languages: ["Hungarian"] },
    { label: "Iceland", value: "IS", languages: ["Icelandic"] },
    { label: "Ireland", value: "IE", languages: ["English", "Irish"] },
    { label: "Italy", value: "IT", languages: ["Italian"] },
    { label: "Latvia", value: "LV", languages: ["Latvian"] },
    { label: "Lithuania", value: "LT", languages: ["Lithuanian"] },
    { label: "Luxembourg", value: "LU", languages: ["Luxembourgish", "French", "German"] },
    { label: "Netherlands", value: "NL", languages: ["Dutch"] },
    { label: "Norway", value: "NO", languages: ["Norwegian"] },
    { label: "Poland", value: "PL", languages: ["Polish"] },
    { label: "Portugal", value: "PT", languages: ["Portuguese"] },
    { label: "Romania", value: "RO", languages: ["Romanian"] },
    { label: "Serbia", value: "RS", languages: ["Serbian"] },
    { label: "Slovakia", value: "SK", languages: ["Slovak"] },
    { label: "Slovenia", value: "SI", languages: ["Slovene"] },
    { label: "Spain", value: "ES", languages: ["Spanish", "Catalan", "Galician", "Basque"] },
    { label: "Sweden", value: "SE", languages: ["Swedish"] },
    { label: "Switzerland", value: "CH", languages: ["German", "French", "Italian", "Romansh"] },
    { label: "United Kingdom", value: "GB", languages: ["English", "Welsh", "Scots Gaelic"] },
    { label: "Turkey", value: "TR", languages: ["Turkish"] }
];

export default europeanCountries;